/**
 * @file 保存学习证书模板
 * @author liudy
 * @see http://api.umucdn.cn/project/111/interface/api/1199
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export interface ISaveCertificateThemeInput {
    group_id: number; // int 对应id

    /* 学习证书信息
    {
        "teacher_name":"daybreak",  //讲师姓名
        "comment":"恭喜你学完课程",  //证书评语
        "theme_id":"123"  //证书主题编号
    } */
    certificate_data: string;
}
export interface ISaveProgramCertificateThemeInput {
    program_id: number; // int 对应id

    /* 学习证书信息
    {
        "teacher_name":"daybreak",  //讲师姓名
        "comment":"恭喜你学完课程",  //证书评语
        "theme_id":"123"  //证书主题编号
    } */
    certificate_data: string;
}
export interface ISaveCertificateThemeOutput {
    status: number;
}

// tslint:disable-next-line:max-line-length
export const saveCertificateConfig = (
    data: ISaveCertificateThemeInput,
): Promise<IResponse<ISaveCertificateThemeOutput>> => {
    return fetchData(Api.COURSE_SAVE_CERTIFICATE_THEME, data);
};

export const saveProgramCertificateConfig = (
    data: ISaveProgramCertificateThemeInput,
): Promise<IResponse<ISaveCertificateThemeOutput>> => {
    return fetchData(Api.PROGRAM_SAVE_CERTIFICATE_THEME, data);
};
